import React, { ReactNode, useEffect, useState } from 'react';
import { COLORS, device } from '../../constants';
import { SCREENSIZES } from '../../constants';
import { headerBackground, headerMockImg } from '../../assets/png/index';
import styled, { css, keyframes } from 'styled-components';
import { Title, Box } from '../index';

type HeaderProps = {
  title?: string;
  color?: string;
  padding?: string;
  background?: string;
  backgroundImage?: string;
  children?: ReactNode;
};

export const HeaderSection = ({
  title,
  color = `${COLORS.HEADER_TEXT_COLOR}`,
  padding = `196px 0`,
  background = headerBackground,
  backgroundImage,
  children,
}: HeaderProps) => {
  const backgroundImageSrc = backgroundImage ?? headerMockImg;
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    const img = new Image();
    img.src = backgroundImageSrc;
    img.onload = () => setIsLoaded(true);
  }, [backgroundImageSrc]);
  return (
    <ExternalWrapper
      $background={background}
      $backgroundImage={isLoaded ? `${backgroundImageSrc}` : ''}
    >
      {isLoaded ? (
        <Box>
          <TextWrapper $padding={padding}>
            <Title
              title={title}
              color={color}
              size={60}
              weight={600}
              lineHeight={70}
            />
            {children}
          </TextWrapper>
        </Box>
      ) : (
        <Skeleton />
      )}
    </ExternalWrapper>
  );
};
export const shimmer = keyframes`
    0% {
        background-position: -200% 0;
    }
    100% {
        background-position: 200% 0;
    }
`;
const ExternalWrapper = styled.div<{
  $background: string;
  $backgroundImage?: string;
}>`
  box-sizing: border-box;

  ${props =>
    props.$backgroundImage
      ? css`
          background-image: url('${props.$backgroundImage}');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        `
      : css`
          background-color: transparent;
          overflow: hidden;
        `}

  min-height: ${SCREENSIZES.MIN_HEIGHT}px;
  @media screen and ${device.md} {
    min-height: 400px;
    span {
      font-size: 30px;
      line-height: 40px;
    }
  }
  @media screen and ${device.sm} {
    min-height: 350px;
    span {
      font-size: 20px;
      line-height: 26px;
    }
    h4 {
      font-size: 15px;
      line-height: 22px;
    }
  }
`;
const Skeleton = styled.div`
  width: 100%;
  min-height: ${SCREENSIZES.MIN_HEIGHT}px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1s infinite;
  @media screen and ${device.md} {
    min-height: 400px;
  }
  @media screen and ${device.sm} {
    min-height: 350px;
  }
`;

const TextWrapper = styled.div<{ $padding: string }>`
  display: flex;
  flex-direction: column;
  padding: ${props => props.$padding};
  gap: 30px;
  @media screen and ${device.lg} {
    padding-top: 100px;
  }
  @media screen and ${device.md} {
    padding-top: 50px;
    padding-bottom: 50px;
  }
`;
